<template>
  <!-- 详情类组件 -->
  <div class="ModuleCourse">
    <Id1 :data="data" v-if="bol1"></Id1>
    <Id2 :data="data" v-else-if="bol2"></Id2>
    <Id3 :data="data" :curriculaId="curriculaId" v-else-if="bol3" :isLast="lastId3" @collectAnswers="pushAnswers" @toAnwers="toAnwers" ref="AAA" @toModify="toModify" @needModify="needModify"></Id3>
    <Id4 :data="data" v-else-if="bol4"></Id4>
    <Id5 :data="data" v-else-if="bol5"></Id5>
    <Id6 :data="data" v-else-if="bol6"></Id6>
    <Id7 :data="data" v-else-if="bol7"></Id7>
    <Id8 :data="data" v-else-if="bol8"></Id8>
    <Id9 :data="data" v-else-if="bol9"></Id9>
    <Id10 :data="data" v-else-if="bol10"></Id10>
  </div>
</template>

<script>

import Id1 from './public/id_1'
import Id2 from './public/id_2'
import Id3 from './public/id_3'
import Id4 from './public/id_4'
import Id5 from './public/id_5'
import Id6 from './public/id_6'
import Id7 from './public/id_7'
import Id8 from './public/id_8'
import Id9 from './public/id_9'
import Id10 from './public/id_10'

export default {
  props: {
    data: Object,
    curriculaId: String,
    lastId3: Boolean
  },
  name: 'CourseDetails',
  data () {
    return {
      bol1: false,
      bol2: false,
      bol3: false,
      bol4: false,
      bol5: false,
      bol6: false,
      bol7: false,
      bol8: false,
      bol9: false,
      bol10: false
    }
  },
  methods: {
    getAnwers () {
      this.$refs.AAA.saveAnwers()
    },
    pushAnswers (arr) {
      this.$emit('collectAnswers', arr)
    },
    toAnwers () {
      this.$emit('toAnwers')
    },
    toModify () {
      this.$emit('toModify')
    },
    Modify () {
      this.$refs.AAA.modifyBol = false
    },
    toInit () {
      this.$refs.AAA.list = []
      this.$refs.AAA.topicList = this.$refs.AAA.Answers
      this.$refs.AAA.init()
    },
    needModify () {
      this.$emit('needModify')
    },
    changeModify () {
      this.$refs.AAA.modifyBol = true
    }
  },
  created () {
    this['bol' + this.data.id] = true
  },
  components: {
    Id1,
    Id2,
    Id3,
    Id4,
    Id5,
    Id6,
    Id7,
    Id8,
    Id9,
    Id10
  }
}
</script>

<style lang="scss">
.ModuleCourse{
  a{
    text-decoration: none;
    color: #296BFF;
    cursor: pointer;
  }
  i{
    font-style: italic;
  }
  b{
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/main.vue